<ion-content class="user-review-modal-content" [fullscreen]="true">
  <div class="modal-inner">
    <div class="modal-message">
      {{ 'i18n.userReview.message' | translate }}
    </div>
    <div class="modal-actions">
      <button class="thumb-btn" (click)="thumbsUp()" aria-label="Thumbs up">
        <ng-container *ngIf="!thumbsUpSelected">
          <img src="/assets/icon/user-review-thumbs-up.svg" alt="Thumbs up" />
        </ng-container>
        <ng-container *ngIf="thumbsUpSelected">
          <img
            src="/assets/icon/user-review-thumbs-up-filled.svg"
            alt="Thumbs up"
          />
        </ng-container>
      </button>
      <button class="thumb-btn" (click)="thumbsDown()" aria-label="Thumbs down">
        <ng-container *ngIf="!thumbsDownSelected">
          <img
            src="/assets/icon/user-review-thumbs-down.svg"
            alt="Thumbs down"
          />
        </ng-container>
        <ng-container *ngIf="thumbsDownSelected">
          <img
            src="/assets/icon/user-review-thumbs-down-filled.svg"
            alt="Thumbs down"
          />
        </ng-container>
      </button>
    </div>
  </div>
</ion-content>
